// extracted by mini-css-extract-plugin
export default {"cbody":"checkout_cbody__FpDgo","box":"checkout_box__Rj-kl","cimg":"checkout_cimg__dSL6Q"};